import classNames from 'classnames';
import { SearchBarCampaign } from '@/components/organisms/search-bar/search-bar-campaign';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import Row from '@/components/utilities/row/row';
import styles from './campaign-page-header.module.scss';

export interface CampaignPageHeaderProps {
  /** Search settings for filters and search bar */
  searchSettings: Content.Components['SearchSettingsDto'];
}

const CampaignPageHeader = ({ searchSettings }: CampaignPageHeaderProps) => {
  return (
    <section className={classNames(styles.component)}>
      <Container>
        <Row className={styles.row}>
          <Column width={{ desktop: 12 }}>
            <div className={styles.searchBarContainer}>
              <SearchBarCampaign
                className={styles.searchBar}
                propDefaultValues={{
                  adultsNumber:
                    searchSettings.selectedPaxDistribution?.adultsNo.toString(),
                  departureDate: searchSettings.selectedDepartureDate
                    ? new Date(searchSettings.selectedDepartureDate.toString())
                    : undefined,
                  departureId: searchSettings.selectedDepartureId?.toString(),
                  destinationIds: searchSettings.selectedDestinationIds?.map(
                    id => id.toString(),
                  ),
                  destinationRegionIds:
                    searchSettings.selectedDestinationRegionIds?.map(id =>
                      id.toString(),
                    ),
                  durationType:
                    searchSettings.selectedPeriodType as Content.Components['PeriodType'],
                  maxDepartureDate: searchSettings.selectedMaxDepartureDate
                    ? new Date(
                        searchSettings.selectedMaxDepartureDate.toString(),
                      )
                    : undefined,
                }}
                searchSettings={searchSettings}
              />
            </div>
          </Column>
        </Row>
      </Container>
    </section>
  );
};

CampaignPageHeader.displayName = 'CampaignPageHeader';

export default CampaignPageHeader;
